import { component } from 'picoapp'
import { addVariant, addItemById, openCart } from '@/lib/cart.js'
import '@/lib/jquery-global.js';
import moment from 'moment'
import datepicker from 'js-datepicker'
import '@fancyapps/fancybox'

export default component((node, ctx) => {

  if (node.dataset.template == 'product.valentines') {
  

    const json = JSON.parse(node.querySelector(".js-product-json").innerHTML);
    const form = node.querySelector("form");

    const { selectedOrFirstAvailableVariant, product } = json;
    let currentVariant = product.variants.filter(
      (v) => v.id === selectedOrFirstAvailableVariant
    )[0];

    let delivery = jQuery(node.querySelector(".js-delivery"));
    let details = jQuery(node.querySelector(".js-details"));

    node.querySelector(".js-delivery-trigger").addEventListener("click", (e) => {
      delivery.fadeIn();
      let top = jQuery(".js-details-top").position().top;
      // jQuery('html, body').animate({ scrollTop: top }, 'fast');
    });

    node.querySelector(".js-delivery-close").addEventListener("click", (e) => {
      delivery.fadeOut();
    });

    node.querySelector(".js-details-trigger").addEventListener("click", (e) => {
      details.fadeIn();
      // jQuery('html, body').animate({ scrollTop: 0 }, 'fast');
    });

    jQuery(".js-details-close").click(function () {
      details.fadeOut();
    });

    let day = moment().format("MMMM Do, YYYY");
    let days = [];
    days.push(day);

    let delivery_date = document.getElementById("delivery_date");

    function addDays(dateObj, numDays) {
      dateObj.setDate(dateObj.getDate() + numDays);
      return dateObj;
    }

    let now = new Date(); //Current date
    now.setHours(now.getHours() + 6)
    let twoDaysFromNow = addDays(now, 2);

    console.log(delivery_date.dataset.blackout_dates);

    let blackout_dates = delivery_date.dataset.blackout_dates.split(",");

    // console.log(blackout_dates)

    let disabledDates = [];

    for (let j = 0; j < blackout_dates.length; j++) {
      let blackout_date_array = blackout_dates[j].split("-");
      let blackout_year = parseInt(blackout_date_array[0]);
      let blackout_month = parseInt(blackout_date_array[1]) - 1;
      let blackout_day = parseInt(blackout_date_array[2]);

      let disabled_date = new Date(blackout_year, blackout_month, blackout_day);

      disabledDates.push(disabled_date);
    }

    // console.log(disabledDates);

    let enabled_dates = [
      new Date(2022, 4, 7).getTime(),
      new Date(2022, 4, 8).getTime(),
    ]

    // console.log(enabled_dates)

    let picker_options = {
      minDate: twoDaysFromNow,
      disabler: (date) => {
        if (enabled_dates.includes(date.getTime())) {
          return false
        } else {
          return true
        }
      }
    };

    const picker = datepicker(delivery_date, picker_options);

    // for(let i = 1; i < 31; i++) {
    //     let new_day = moment().add(i, 'days').format('MMMM Do, YYYY')
    //     days.push(new_day);
    // }

    // for (let i = 0; i < days.length; i++) {
    //   let option = document.createElement('option');
    //   option.value = option.text = days[i];
    //   delivery_date.add(option);
    // }

    let checkboxes = document.getElementsByName("add_ons");

    let shipping = document.getElementById("shipping");

    let delivery_or_pickup = document.getElementById("delivery_or_pickup");

    async function addProducts(form) {
      await $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: $(form).serialize(),
        success: function () {
          console.log("succeeded!");
        },
        error: function () {
          console.log("failed!");
        },
      });

      let has_add_ons = false;

      for (let checkbox of checkboxes) {
        if (checkbox.checked) {
          has_add_ons = true;
          // console.log(checkbox.value)
          await addItemById(checkbox.value, 1);
        }
      }

      if (delivery_or_pickup.value == "Delivery") {
        await addItemById(
          shipping.options[shipping.selectedIndex].dataset.value,
          1
        );
      }

      if (!has_add_ons) {
        await addItemById("", 0);
      }
    }

    // form.addEventListener('submit', e => {
    //   e.preventDefault()
    //   currentVariant = product.variants.filter(v => v.id === parseInt(form.elements.id.value))[0]

    //   addVariant(currentVariant, form.elements.quantity.value)
    //   console.log(json)
    // })

    form.addEventListener("submit", (e) => {
      e.preventDefault();

      if (jQuery("#delivery_date").val() != "") {
        if (jQuery(".js-delivery-or-pickup").val() == "Pickup") {
          addProducts(form);
        } else {
          if (jQuery(".js-name").val() != "") {
            addProducts(form);
          } else {
            alert("You must add delivery details.");
          }
        }
      } else {
        alert("You must select a date.");
      }
    });

    // const delivery_or_pickup = node.querySelector('.js-delivery-or-pickup')

    // console.log(delivery_or_pickup

    jQuery('.js-delivery-or-pickup').change(function() {

      if (jQuery(this).val() == 'Pickup') {
        jQuery('.js-final-step').text('Step Four')
        jQuery('.js-step-five').text('Step Three')
        jQuery('.js-other-steps').hide();
        jQuery('.js-pickup-step').show();

      } else if (jQuery(this).val() == 'Delivery') {
        jQuery('.js-final-step').text('Step Six')
        jQuery('.js-step-five').text('Step Five')
        jQuery('.js-other-steps').show();
        jQuery('.js-pickup-step').hide();
      }

    })

  
  } else {


    const json = JSON.parse(node.querySelector('.js-product-json').innerHTML)
    const form = node.querySelector('form')

    const { selectedOrFirstAvailableVariant, product } = json
    let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0]

    let delivery = jQuery(node.querySelector('.js-delivery'))
    let details = jQuery(node.querySelector('.js-details'))

    node.querySelector('.js-delivery-trigger').addEventListener('click', (e) => {
      delivery.fadeIn();
      let top = jQuery('.js-details-top').position().top;
      // jQuery('html, body').animate({ scrollTop: top }, 'fast');
    })

    node.querySelector('.js-delivery-close').addEventListener('click', (e) => {
      delivery.fadeOut();
    })

    node.querySelector('.js-details-trigger').addEventListener('click', (e) => {
      details.addClass('details-visible');
      // jQuery('html, body').animate({ scrollTop: 0 }, 'fast');
    })


    // details pickup
    let details_pickup = jQuery(node.querySelector('.js-details-pickup'))

    node.querySelector('.js-details-trigger-pickup').addEventListener('click', (e) => {
      details_pickup.addClass('details-visible');
    })


    jQuery('.js-details-close').click(function() {
      details.removeClass('details-visible');
      details_pickup.removeClass('details-visible');
    })

    let day = moment().format('MMMM Do, YYYY');
    let days = []
    days.push(day)

    let delivery_date = document.getElementById('delivery_date')


    function addDays(dateObj, numDays) {
      dateObj.setDate(dateObj.getDate() + numDays);
      return dateObj;
    }
  
    let now = new Date(); //Current date
    now.setHours(now.getHours() + 6)
    let twoDaysFromNow = addDays(now, 2);

    let blackout_dates = delivery_date.dataset.blackout_dates.split(',')

    // console.log(blackout_dates)

    let disabledDates = []

    for (let j = 0; j < blackout_dates.length; j++) {

      let blackout_date_array = blackout_dates[j].split('-')
      let blackout_year = parseInt(blackout_date_array[0])
      let blackout_month = parseInt(blackout_date_array[1]) - 1
      let blackout_day = parseInt(blackout_date_array[2])

      let disabled_date = new Date(blackout_year, blackout_month, blackout_day)

      disabledDates.push(disabled_date)
    }

    let picker_options = {
      minDate: twoDaysFromNow,
      disabledDates: disabledDates,
      disabler: date => ((date.getDay() === 0) || (date.getDay() == 1))
    }

    const picker = datepicker(delivery_date, picker_options)

    // for(let i = 1; i < 31; i++) {
    //     let new_day = moment().add(i, 'days').format('MMMM Do, YYYY')
    //     days.push(new_day);
    // }

    // for (let i = 0; i < days.length; i++) {
    //   let option = document.createElement('option');
    //   option.value = option.text = days[i];
    //   delivery_date.add(option);
    // }

    
    let checkboxes = document.getElementsByName('add_ons');

    let shipping = document.getElementById('shipping')

    let delivery_or_pickup = document.getElementById('delivery_or_pickup')

    async function addProducts(form) {

      await $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: $(form).serialize(),
        success: function() {
          console.log('succeeded!');
        },
        error: function() {
          console.log('failed!');
        }
      });

      let has_add_ons = false

      for (let checkbox of checkboxes) {
        
        if (checkbox.checked) {
          has_add_ons = true
          // console.log(checkbox.value)
          await addItemById(checkbox.value, 1)
        }
      }

      if (delivery_or_pickup.value == 'Delivery') {
        await addItemById(shipping.options[shipping.selectedIndex].dataset.value, 1);
      }

      if (!has_add_ons) {
        await openCart()
      }

    }


    // form.addEventListener('submit', e => {
    //   e.preventDefault()
    //   currentVariant = product.variants.filter(v => v.id === parseInt(form.elements.id.value))[0]

    //   addVariant(currentVariant, form.elements.quantity.value)
    //   console.log(json)
    // })

    form.addEventListener("submit", (e) => {
      e.preventDefault();

      if (jQuery("#delivery_date").val() != "") {
        if (jQuery('.js-delivery-or-pickup').val() == 'Pickup') {
          addProducts(form);
        } else {
          if (jQuery(".js-name").val() != "") {
            addProducts(form);
          } else {
            alert("You must add delivery details.");
          }
        }
      } else {
        alert("You must select a date.");
      }
    });


    // const delivery_or_pickup = node.querySelector('.js-delivery-or-pickup')
      
    jQuery('.js-delivery-or-pickup').change(function() {

      if (jQuery(this).val() == 'Pickup') {
        jQuery('.js-final-step').text('Step Four')
        jQuery('.js-step-five').text('Step Three')
        jQuery('.js-other-steps').hide();
        jQuery('.js-pickup-step').show();

      } else if (jQuery(this).val() == 'Delivery') {
        jQuery('.js-final-step').text('Step Six')
        jQuery('.js-step-five').text('Step Five')
        jQuery('.js-other-steps').show();
        jQuery('.js-pickup-step').hide();
      }

    })


  }
  

})
